<!-- HTML Template -->
<template>
  <div id="top-layout">
    <div id="appHeader">
      <h1 class="flex-1">{{ $t("header.title") }}</h1>

      <div class="links flex-1" v-if="user !== null && user.role === Roles.superAdmin">
        <router-link :to="{name:'clientList'}"
                     v-bind:class="[{ 'header-link-active': $route.path.includes('clients')}, 'header-link']">
          <svg width="14px" height="15px" class="icon">
            <use xlink:href="#user"></use>
          </svg>
          {{ $t("header.accounts_users") }}
        </router-link>

        <router-link :to="{name:'adminList'}"
                     v-bind:class="[{ 'header-link-active': $route.path.includes('admins')}, 'header-link']">
          <svg width="18px" height="19px" class="icon">
            <use xlink:href="#admin"></use>
          </svg>
          {{ $t("header.accounts_admins") }}
        </router-link>
      </div>

      <div class="links flex-1" v-if="user !== null && user.role === Roles.admin">
        <router-link :to="{name:'clientList'}"
                     v-bind:class="[{ 'header-link-active': $route.path.includes('clients')}, 'header-link']">
          <svg width="14px" height="15px" class="icon">
            <use xlink:href="#user"></use>
          </svg>
          {{ $t("header.accounts_users") }}
        </router-link>
      </div>

      <div class="links flex-1" v-if="user !== null && user.role === Roles.client">
        <router-link :to="{name:'sharedFiles'}"
                     v-bind:class="[{ 'header-link-active': $route.path.includes('shared')}, 'header-link']">
          <span class="icon" :data-notifications="sharedCount" v-if="sharedCount > 0">
            <svg width="17px" height="14px">
              <use xlink:href="#shared"></use>
            </svg>
          </span>
          <span class="icon" v-if="sharedCount === 0">
            <svg width="17px" height="14px">
              <use xlink:href="#shared"></use>
            </svg>
          </span>
          {{ $t("header.files_shared") }}
        </router-link>

        <router-link :to="{name:'myFiles'}"
                     v-bind:class="[{ 'header-link-active': $route.path.includes('mine')}, 'header-link']">
          <span class="icon" :data-notifications="mineCount" v-if="mineCount > 0">
            <svg width="15px" height="16px">
              <use xlink:href="#file"></use>
            </svg>
          </span>
          <span class="icon" v-if="mineCount === 0">
            <svg width="15px" height="16px">
              <use xlink:href="#file"></use>
            </svg>
          </span>
          {{ $t("header.files_mine") }}
        </router-link>
      </div>

      <div class="dropdown" style="float:right;" v-if="user !== null">
        <div class="dropbtn" id="my-user">
          <div class="avatar-circle">
            <span class="initials">{{Utils.getInitials(user)}}</span>
          </div>
          <div>{{user.displayName}}</div>
          <i class="fas fa-angle-down"></i>
        </div>
        <div class="dropdown-content">
          <a v-on:click="goToProfile()">{{ $t("header.my_profile") }}</a>
          <a v-on:click="logout()">{{ $t("header.logout") }}</a>
        </div>
      </div>
      <div class="dropdown" style="float:right;" v-if="user === null">
        <div class="dropbtn">
          {{$t(`languages.${this.$i18n.locale}`)}}
        </div>
        <div class="dropdown-content">
          <a v-on:click="changeLocale('en')">{{ $t("languages.en") }}</a>
          <a v-on:click="changeLocale('fr')">{{ $t("languages.fr") }}</a>
        </div>
      </div>
    </div>
    <div id="alert-bar">
      <div v-on:click="clearAlerts" v-if="alert.message" :class="`alert ${alert.type}`">
        {{alert.message}}
        <i class="fas fa-times"></i>
      </div>
    </div>
  </div>
</template>
<script>
  import userService from "../services/userService.js";
  import Utils from "../services/utils.js";
  import Roles from "../models/Roles.js"

  export default {
    data() {
      return {
        Roles: Roles, // need to be mapped to be used in template
        Utils: Utils // idem
      };
    },
    computed: {
      sharedCount() {
        return this.$store.state.file.sharedCount;
      },
      mineCount() {
        return this.$store.state.file.mineCount;
      },
      user() {
        return this.$store.state.user.current;
      },
      alert() {
        return this.$store.state.alert
      }
    },
    watch: {
      '$route'(to, from) {
        this.$store.dispatch('file/count');
      }
    },
    methods: {
      logout() {
        userService.logout();
        this.$store.dispatch('user/logout');
        location.reload();
      },
      clearAlerts() {
        this.$store.dispatch('alert/clear');
      },
      goToProfile() {
        this.$router.push({name: 'profileManage'})
      },
      changeLocale(locale) {
        this.$i18n.locale = locale;
        localStorage.setItem('locale', locale); // save
      }
    },
    mounted() {
      this.$store.dispatch('file/count');
    }
  };
</script>
<style lang="scss" scoped>
  @import '../style/global.scss';
  @import '../style/dropdown.scss';

  #appHeader {
    background-color: $charcoal;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    color: white;
    padding: 1%;
  }

  #appHeader > h1 {
    @extend %font-semi-bold;
    color: $bluish-grey;
    font-size: 23px;
  }

  #my-user, .header-link, .links {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }

  #my-user i {
    margin-top: 3px;
    margin-left: 5px;
  }

  .header-link {
    @extend %font-semi-bold;
    color: $bluish-grey;
    text-decoration: none;

    margin: 0 25px;
  }

  .icon {
    margin-right: 5px;
    color: $bluish-grey-70;
  }

  .header-link-active {
    color: white;
  }

  .header-link-active .icon {
    color: $blue !important;
  }

  .flex-3 {
    flex-grow: 3;
  }

  .flex-2 {
    flex-grow: 2;
  }

  .flex-1 {
    flex-grow: 1;
  }

  .alert {
    @extend %font-semi-bold;
    color: white;
    padding: 10px;
    cursor: pointer;

    @extend %flex-line;
    justify-content: space-between;
  }

  .alert-error {
    background-color: red;
  }

  .alert-success {
    background-color: green;
  }

  /* make sure the element has position: relative */
  [data-notifications] {
    position: relative;
  }

  /* append the notification badge after it */
  [data-notifications]:after {
    /* the burger */
    content: attr(data-notifications);

    /* the fries */
    position: absolute;
    background: $red;
    border-radius: 50%;
    padding: 0.1em 0.5em;
    font-size: 12px;
    color: white;
    right: -10px;
    top: -10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/appHeader.vue